import { MOXFIELD, TCGPLAYER, DELVERSCAN } from "./constants";

const TEMPLATE_BY_PLATFORM = {
  [MOXFIELD]: ({
    quantity,
    name,
    set,
    collectorNumber,
    isFoil,
  }) => (
    `${quantity} ${name} (${set}) ${collectorNumber}${isFoil ? " *F*" : ""}`
  ),
  [TCGPLAYER]: ({
    quantity,
    name,
    set,
    collectorNumber,
    isFoil,
  }) => (
    `${quantity},${name},${collectorNumber},${set},${isFoil ? "Foil" : "Normal"}`
  ),
  [DELVERSCAN]: ({
    quantity,
    name,
    set,
    collectorNumber,
    isFoil,
  }) => (
    `"${quantity}x","${name}","${isFoil ? "Foil" : ""}","(${set})","${collectorNumber}"`
  ),
}

export const convertToCSV = (arr, platform) => {
  const template = TEMPLATE_BY_PLATFORM[platform];

  return arr.map(template).join("\n")
};

const REGEX_BY_PLATFORM = {
  [MOXFIELD]: /(\d+)\s(.+?)\s\((.+?)\)\s(\d+p?)(\s\*F\*)?(\s#!.+)?/g,
  [TCGPLAYER]: /(\d+),(.+?),(\d+p?),(.+?),(.+?)/g,
  [DELVERSCAN]: /"(\d)+x","(.+?)","(.+?)?","\((.+?)\)","(\d+p?)"/g,
};

const INDEX_BY_PLATFORM = {
  [MOXFIELD]: {
    quantity: 1,
    name: 2,
    set: 3,
    collectorNumber: 4,
    isFoil: 5,
  },
  [TCGPLAYER]: {
    quantity: 1,
    name: 2,
    collectorNumber: 3,
    set: 4,
    isFoil: 5,
  },
  [DELVERSCAN]: {
    quantity: 1,
    name: 2,
    collectorNumber: 5,
    set: 4,
    isFoil: 3,
  }
};

export function parseList(text, platform) {
  if (!text) return [];

  const rows = text.split("\n");//.filter((line) => line !== "");

  const index = INDEX_BY_PLATFORM[platform];

  return rows.map((cardData, i) => {
    const regex = REGEX_BY_PLATFORM[platform];
    const matches = regex.exec(cardData);
    regex.lastIndex = 0;

    if (matches === null) return {};

    let isFoil = false;
    if (platform === MOXFIELD) {
      isFoil = matches[index.isFoil] ? true : false;
    } else if (platform === TCGPLAYER) {
      isFoil = matches[index.isFoil] === "F";
    } else if (platform === DELVERSCAN) {
      isFoil = matches[index.isFoil] === "Foil";
    }

    return {
      quantity: parseInt(matches[index.quantity]),
      name: matches[index.name],
      set: matches[index.set],
      collectorNumber: matches[index.collectorNumber],
      isFoil,
    };
  });
};

export function detectPlatform(text) {
  if (!text.trim()) return null;

  const lines = text.split('\n').filter(line => line.trim());
  if (lines.length === 0) return null;

  const sampleLines = lines.slice(0, Math.min(5, lines.length));

  let moxfieldScore = 0;
  let tcgplayerScore = 0;
  let delverscanScore = 0;

  sampleLines.forEach(line => {
    if (REGEX_BY_PLATFORM[MOXFIELD].test(line)) {
      moxfieldScore++;
    }
    REGEX_BY_PLATFORM[MOXFIELD].lastIndex = 0;

    if (REGEX_BY_PLATFORM[TCGPLAYER].test(line)) {
      tcgplayerScore++;
    }
    REGEX_BY_PLATFORM[TCGPLAYER].lastIndex = 0;

    if (REGEX_BY_PLATFORM[DELVERSCAN].test(line)) {
      delverscanScore++;
    }
    REGEX_BY_PLATFORM[DELVERSCAN].lastIndex = 0;
  });

  if (moxfieldScore > tcgplayerScore && moxfieldScore > delverscanScore) {
    return MOXFIELD;
  } else if (tcgplayerScore > moxfieldScore && tcgplayerScore > delverscanScore) {
    return TCGPLAYER;
  } else if (delverscanScore > 0) {
    return DELVERSCAN;
  }

  return null;
}
